export default __webpack_public_path__ + "media/images/footer/elo-787159e08ab2131f0bd5880943b70089.svg";